import {getDefaultCustomerOrdersFilter, getDefaultCustomersFilter, getDefaultOrdersByCustomerFilter, getDefaultReviewsFilter, getDefaultSalesFilter, getDefaultUnfinishedCartFilter} from "../utils/constants";
import { GLOBAL_FILTER_TYPE } from "../utils/enums";

let singleton = Symbol();
let singletonEnforcer = Symbol();

// Single source of the per-type defaults: the initial state and the reset button read the same
// map, so a filter cannot reset to something the page never started with.
const DEFAULT_FILTER_FACTORY = {
    [GLOBAL_FILTER_TYPE.reviews]: getDefaultReviewsFilter,
    [GLOBAL_FILTER_TYPE.customers]: getDefaultCustomersFilter,
    [GLOBAL_FILTER_TYPE.sales]: getDefaultSalesFilter,
    [GLOBAL_FILTER_TYPE.orders]: getDefaultSalesFilter,
    [GLOBAL_FILTER_TYPE.customerOrders]: getDefaultCustomerOrdersFilter,
    [GLOBAL_FILTER_TYPE.unfinishedCart]: getDefaultUnfinishedCartFilter,
    [GLOBAL_FILTER_TYPE.orderByCustomer]: getDefaultOrdersByCustomerFilter,
};

export default class GlobalFilterDataService {
    constructor(enforcer) {
        if (enforcer !== singletonEnforcer)
            throw new Error("Instantiation failed: use GlobalFilterDataService.instance() instead of new.");
        
        //Init data
        this.filters = Object.entries(DEFAULT_FILTER_FACTORY)
            .reduce((acc, [type, createDefault]) => ({ ...acc, [type]: createDefault() }), {});
    }

    static get instance() {
        if (!this[singleton]) {
            this[singleton] = new GlobalFilterDataService(singletonEnforcer);
        }

        return this[singleton];
    }

    static set instance(v) {
        throw new Error("Can't change constant property!");
    }

    setFilter(type, data) {
        this.filters[type] = data;
    }

    getFilter(type) {
        return this.filters[type];
    }

    // The factories build fresh objects (dates are computed per call), so the caller always gets
    // an unshared value and "today" means today, not the day the tab was opened.
    getDefaultFilter(type) {
        const createDefault = DEFAULT_FILTER_FACTORY[type];
        return createDefault ? createDefault() : null;
    }

    resetFilter(type) {
        const defaultFilter = this.getDefaultFilter(type);
        if (defaultFilter) {
            this.filters[type] = defaultFilter;
        }
        return defaultFilter;
    }
}
